export enum Table {
	COLLECTIONS = 'collections',
	SENTENCES = 'sentences'
}

export interface DBModel {
	TABLE: Table;
	id: string;
}

export class DBCollection implements DBModel {
	TABLE = Table.COLLECTIONS;
	id: string = ""; // filename
	knownLanguage: string = "";
	targetLanguage: string = "";
	type: string = "";
	count: number = 0;
	downloadedAt: number = 0;
	doneCount: number = 0;
	todoCount: number = 0;
	repeatCount: number = 0;
	enabledVoices: string[] = [];
	speechSpeed: number = 0.8; // default to 80% (slow)
}

export enum SentenceStatus {
	TODO = 0,
	REPEAT = 1,
	DONE = 2,
	SKIPPED = 3,
	
	IGNORE = 100
}

export class DBSentence implements DBModel {
	TABLE = Table.SENTENCES;
	id: string = ""; // sentenceId
	order: number = 0;
	collectionId: string = ""; // reference to collection
	knownSentence: string = "";
	targetSentence: string = "";
	complexity: number = 0;
	status: SentenceStatus = SentenceStatus.TODO;
	doneAt: number = 0; // timestamp when marked as done
}

export const DB_SAMPLES: DBModel[] = [new DBCollection(), new DBSentence()];